module.exports = __webpack_public_path__ + "img/ES0136.a57785f7.png";